[
  {
    "code": "AG",
    "name": "AGRIGENTO",
    "region": "SICILIA"
  },
  {
    "code": "AL",
    "name": "ALESSANDRIA",
    "region": "PIEMONTE"
  },
  {
    "code": "AN",
    "name": "ANCONA",
    "region": "MARCHE"
  },
  {
    "code": "AO",
    "name": "AOSTA",
    "region": "VALLE D'AOSTA"
  },
  {
    "code": "AP",
    "name": "ASCOLI PICENO",
    "region": "MARCHE"
  },
  {
    "code": "AQ",
    "name": "L'AQUILA",
    "region": "ABRUZZO"
  },
  {
    "code": "AR",
    "name": "AREZZO",
    "region": "TOSCANA"
  },
  {
    "code": "AT",
    "name": "ASTI",
    "region": "PIEMONTE"
  },
  {
    "code": "AV",
    "name": "AVELLINO",
    "region": "CAMPANIA"
  },
  {
    "code": "BA",
    "name": "BARI",
    "region": "PUGLIA"
  },
  {
    "code": "BG",
    "name": "BERGAMO",
    "region": "LOMBARDIA"
  },
  {
    "code": "BI",
    "name": "BIELLA",
    "region": "PIEMONTE"
  },
  {
    "code": "BL",
    "name": "BELLUNO",
    "region": "VENETO"
  },
  {
    "code": "BN",
    "name": "BENEVENTO",
    "region": "CAMPANIA"
  },
  {
    "code": "BO",
    "name": "BOLOGNA",
    "region": "EMILIA ROMAGNA"
  },
  {
    "code": "BR",
    "name": "BRINDISI",
    "region": "PUGLIA"
  },
  {
    "code": "BS",
    "name": "BRESCIA",
    "region": "LOMBARDIA"
  },
  {
    "code": "BT",
    "name": "BARLETTA ANDRIA TRANI",
    "region": "PUGLIA"
  },
  {
    "code": "BZ",
    "name": "BOLZANO",
    "region": "TRENTINO ALTO ADIGE"
  },
  {
    "code": "CA",
    "name": "CAGLIARI",
    "region": "SARDEGNA"
  },
  {
    "code": "CB",
    "name": "CAMPOBASSO",
    "region": "MOLISE"
  },
  {
    "code": "CE",
    "name": "CASERTA",
    "region": "CAMPANIA"
  },
  {
    "code": "CH",
    "name": "CHIETI",
    "region": "ABRUZZO"
  },
  {
    "code": "CI",
    "name": "CARBONIA IGLESIAS",
    "region": "SARDEGNA"
  },
  {
    "code": "CL",
    "name": "CALTANISSETTA",
    "region": "SICILIA"
  },
  {
    "code": "CN",
    "name": "CUNEO",
    "region": "PIEMONTE"
  },
  {
    "code": "CO",
    "name": "COMO",
    "region": "LOMBARDIA"
  },
  {
    "code": "CR",
    "name": "CREMONA",
    "region": "LOMBARDIA"
  },
  {
    "code": "CS",
    "name": "COSENZA",
    "region": "CALABRIA"
  },
  {
    "code": "CT",
    "name": "CATANIA",
    "region": "SICILIA"
  },
  {
    "code": "CZ",
    "name": "CATANZARO",
    "region": "CALABRIA"
  },
  {
    "code": "EN",
    "name": "ENNA",
    "region": "SICILIA"
  },
  {
    "code": "FE",
    "name": "FERRARA",
    "region": "EMILIA ROMAGNA"
  },
  {
    "code": "FG",
    "name": "FOGGIA",
    "region": "PUGLIA"
  },
  {
    "code": "FI",
    "name": "FIRENZE",
    "region": "TOSCANA"
  },
  {
    "code": "FM",
    "name": "FERMO",
    "region": "MARCHE"
  },
  {
    "code": "FC",
    "name": "FORLI'-CESENA",
    "region": "EMILIA ROMAGNA"
  },
  {
    "code": "FR",
    "name": "FROSINONE",
    "region": "LAZIO"
  },
  {
    "code": "GE",
    "name": "GENOVA",
    "region": "LIGURIA"
  },
  {
    "code": "GO",
    "name": "GORIZIA",
    "region": "FRIULI VENEZIA GIULIA"
  },
  {
    "code": "GR",
    "name": "GROSSETO",
    "region": "TOSCANA"
  },
  {
    "code": "IM",
    "name": "IMPERIA",
    "region": "LIGURIA"
  },
  {
    "code": "IS",
    "name": "ISERNIA",
    "region": "MOLISE"
  },
  {
    "code": "KR",
    "name": "CROTONE",
    "region": "CALABRIA"
  },
  {
    "code": "LC",
    "name": "LECCO",
    "region": "LOMBARDIA"
  },
  {
    "code": "LE",
    "name": "LECCE",
    "region": "PUGLIA"
  },
  {
    "code": "LI",
    "name": "LIVORNO",
    "region": "TOSCANA"
  },
  {
    "code": "LO",
    "name": "LODI",
    "region": "LOMBARDIA"
  },
  {
    "code": "LT",
    "name": "LATINA",
    "region": "LAZIO"
  },
  {
    "code": "LU",
    "name": "LUCCA",
    "region": "TOSCANA"
  },
  {
    "code": "MB",
    "name": "MONZA E DELLA BRIANZA",
    "region": "LOMBARDIA"
  },
  {
    "code": "MC",
    "name": "MACERATA",
    "region": "MARCHE"
  },
  {
    "code": "ME",
    "name": "MESSINA",
    "region": "SICILIA"
  },
  {
    "code": "MI",
    "name": "MILANO",
    "region": "LOMBARDIA"
  },
  {
    "code": "MN",
    "name": "MANTOVA",
    "region": "LOMBARDIA"
  },
  {
    "code": "MO",
    "name": "MODENA",
    "region": "EMILIA ROMAGNA"
  },
  {
    "code": "MS",
    "name": "MASSA CARRARA",
    "region": "TOSCANA"
  },
  {
    "code": "MT",
    "name": "MATERA",
    "region": "BASILICATA"
  },
  {
    "code": "NA",
    "name": "NAPOLI",
    "region": "CAMPANIA"
  },
  {
    "code": "NO",
    "name": "NOVARA",
    "region": "PIEMONTE"
  },
  {
    "code": "NU",
    "name": "NUORO",
    "region": "SARDEGNA"
  },
  {
    "code": "OG",
    "name": "OGLIASTRA",
    "region": "SARDEGNA"
  },
  {
    "code": "OR",
    "name": "ORISTANO",
    "region": "SARDEGNA"
  },
  {
    "code": "OT",
    "name": "OLBIA TEMPIO",
    "region": "SARDEGNA"
  },
  {
    "code": "PA",
    "name": "PALERMO",
    "region": "SICILIA"
  },
  {
    "code": "PC",
    "name": "PIACENZA",
    "region": "EMILIA ROMAGNA"
  },
  {
    "code": "PD",
    "name": "PADOVA",
    "region": "VENETO"
  },
  {
    "code": "PE",
    "name": "PESCARA",
    "region": "ABRUZZO"
  },
  {
    "code": "PG",
    "name": "PERUGIA",
    "region": "UMBRIA"
  },
  {
    "code": "PI",
    "name": "PISA",
    "region": "TOSCANA"
  },
  {
    "code": "PN",
    "name": "PORDENONE",
    "region": "FRIULI VENEZIA GIULIA"
  },
  {
    "code": "PO",
    "name": "PRATO",
    "region": "TOSCANA"
  },
  {
    "code": "PR",
    "name": "PARMA",
    "region": "EMILIA ROMAGNA"
  },
  {
    "code": "PS",
    "name": "PESARO URBINO",
    "region": "MARCHE"
  },
  {
    "code": "PT",
    "name": "PISTOIA",
    "region": "TOSCANA"
  },
  {
    "code": "PV",
    "name": "PAVIA",
    "region": "LOMBARDIA"
  },
  {
    "code": "PZ",
    "name": "POTENZA",
    "region": "BASILICATA"
  },
  {
    "code": "RA",
    "name": "RAVENNA",
    "region": "EMILIA ROMAGNA"
  },
  {
    "code": "RC",
    "name": "REGGIO CALABRIA",
    "region": "CALABRIA"
  },
  {
    "code": "RE",
    "name": "REGGIO EMILIA",
    "region": "EMILIA ROMAGNA"
  },
  {
    "code": "RG",
    "name": "RAGUSA",
    "region": "SICILIA"
  },
  {
    "code": "RI",
    "name": "RIETI",
    "region": "LAZIO"
  },
  {
    "code": "RM",
    "name": "ROMA",
    "region": "LAZIO"
  },
  {
    "code": "RN",
    "name": "RIMINI",
    "region": "EMILIA ROMAGNA"
  },
  {
    "code": "RO",
    "name": "ROVIGO",
    "region": "VENETO"
  },
  {
    "code": "SA",
    "name": "SALERNO",
    "region": "CAMPANIA"
  },
  {
    "code": "SI",
    "name": "SIENA",
    "region": "TOSCANA"
  },
  {
    "code": "SO",
    "name": "SONDRIO",
    "region": "LOMBARDIA"
  },
  {
    "code": "SP",
    "name": "LA SPEZIA",
    "region": "LIGURIA"
  },
  {
    "code": "SR",
    "name": "SIRACUSA",
    "region": "SICILIA"
  },
  {
    "code": "SS",
    "name": "SASSARI",
    "region": "SARDEGNA"
  },
  {
    "code": "SU",
    "name": "SUD SARDEGNA",
    "region": "SARDEGNA"
  },
  {
    "code": "SV",
    "name": "SAVONA",
    "region": "LIGURIA"
  },
  {
    "code": "TA",
    "name": "TARANTO",
    "region": "PUGLIA"
  },
  {
    "code": "TE",
    "name": "TERAMO",
    "region": "ABRUZZO"
  },
  {
    "code": "TN",
    "name": "TRENTO",
    "region": "TRENTINO ALTO ADIGE"
  },
  {
    "code": "TO",
    "name": "TORINO",
    "region": "PIEMONTE"
  },
  {
    "code": "TP",
    "name": "TRAPANI",
    "region": "SICILIA"
  },
  {
    "code": "TR",
    "name": "TERNI",
    "region": "UMBRIA"
  },
  {
    "code": "TS",
    "name": "TRIESTE",
    "region": "FRIULI VENEZIA GIULIA"
  },
  {
    "code": "TV",
    "name": "TREVISO",
    "region": "VENETO"
  },
  {
    "code": "UD",
    "name": "UDINE",
    "region": "FRIULI VENEZIA GIULIA"
  },
  {
    "code": "VA",
    "name": "VARESE",
    "region": "LOMBARDIA"
  },
  {
    "code": "VB",
    "name": "VERBANO C.O.",
    "region": "PIEMONTE"
  },
  {
    "code": "VC",
    "name": "VERCELLI",
    "region": "PIEMONTE"
  },
  {
    "code": "VE",
    "name": "VENEZIA",
    "region": "VENETO"
  },
  {
    "code": "VI",
    "name": "VICENZA",
    "region": "VENETO"
  },
  {
    "code": "VR",
    "name": "VERONA",
    "region": "VENETO"
  },
  {
    "code": "VS",
    "name": "MEDIO CAMPIDANO",
    "region": "SARDEGNA"
  },
  {
    "code": "VT",
    "name": "VITERBO",
    "region": "LAZIO"
  },
  {
    "code": "VV",
    "name": "VIBO VALENTIA",
    "region": "CALABRIA"
  }
]